import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "doc_preview-container" }
const _hoisted_2 = { class: "doc-title" }
const _hoisted_3 = { class: "contact" }
const _hoisted_4 = { class: "date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!
  const _component_shadow_block = _resolveComponent("shadow-block")!

  return (_openBlock(), _createBlock(_component_shadow_block, { class: "mb16 sb-doc_preview" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.doc?.name), 1),
        _createElementVNode("div", {
          class: "download-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.download()))
        }, [
          _createVNode(_component_DownloadIcon)
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.doc?.contact.name), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["status", _ctx.status_class])
        }, _toDisplayString(_ctx.doc?.status_text), 3),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.doc?.date_create), 1)
      ])
    ]),
    _: 1
  }))
}